"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LensUpstreamFlowsQueryGrid = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var React = require("react");
var Localize_1 = require("../../../gen-src/Localize");
var LensUpstreamFlowsQueryGql_1 = require("../../queries/LensUpstreamFlowsQueryGql");
var FlowsDisplayGrid_1 = require("../sharedDisplayGrid/FlowsDisplayGrid");
function selectConnectionListResult(resultData) {
    return (resultData === null || resultData === void 0 ? void 0 : resultData.lenses[0]) && resultData.lenses[0].upstreamFlowsConnection;
}
var LensUpstreamFlowsQueryGrid = function (props) {
    var emptyGridMessage = Localize_1.Messages.EmptyUpstreamFlowsLineageGridMessage();
    return (
    // Query without Selection
    React.createElement(data_catalog_shared_1.PaginatedQueryWrapper, { queryGql: LensUpstreamFlowsQueryGql_1.LensUpstreamFlowsQueryGql, partialQueryVariables: {
            vizportalUrlId: props.vizportalUrlId,
            orderBy: props.orderBy,
        }, selectConnectionListResult: selectConnectionListResult, mapResultNode: FlowsDisplayGrid_1.getRowDataForFlow }, function (_a) {
        var rowStore = _a.rowStore;
        return React.createElement(FlowsDisplayGrid_1.FlowsDisplayGrid, { rowStore: rowStore, emptyGridMessage: emptyGridMessage, rowCount: props.rowCount, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder });
    }));
};
exports.LensUpstreamFlowsQueryGrid = LensUpstreamFlowsQueryGrid;
//# sourceMappingURL=LensUpstreamFlowsQueryGrid.js.map